import { commonNewClassnames } from '@common';

const prefix = 'common-ui';
export const newClassnamesForUI = (name) => commonNewClassnames(prefix + '-' + name);

export const DefaultFormat = {
    Month: "MM/yyyy",
    DATE: "dd/MM/yyyy",
    TIME: "HH:mm",
    TIMEWITHSECOND: "HH:mm:ss",
    LANGUAGE: "",
    Year:"yyyy"
};

export const I18N = {
    b: $$.I18N.uploader.b,
    kb: $$.I18N.uploader.kb,
    mb: $$.I18N.uploader.mb,
    gb: $$.I18N.uploader.gb,
    tb: $$.I18N.uploader.tb,
};

/* 
var(--red-2) => var(--red-2)
#123456 => #123456
red-2 => var(--red-2)
red => var(--red-6)
*/
export const convertColor = (c, index = 6) => {
    if (c == null) {
        return c;
    }
    if (c.indexOf('var') === 0 || c.indexOf('#') === 0) {
        return c;
    }
    if (isNaN(Number(c[c.length - 1]))) {
        c += '-' + index;
    }
    return `var(--${c})`;
};
export const convertSize = size => {
    if (size == null) {
        return size;
    }
    if (typeof size == 'number') {
        return size + 'px';
    }
    if (size.indexOf('var') == 0) {
        return size;
    }
    if (size.indexOf('font') == 0) {
        return `var(--${size})`;
    }
    return size;
};

// check upload files
export const checkFile = (file, fileTypes, maxSize) => {
    let errorText = '';
    if (!checkFileType(file, fileTypes)) {
        errorText = $$.I18N.uploader.notSupported;
    }
    else if (!file.size) {
        errorText = $$.I18N.uploader.notZoreKB;
    }
    else if (!checkFileSize(file, maxSize)) {
        errorText = $$.I18N.uploader.exceedMaxFileSize.replace(/\{(\d+)\}/g, maxSize);
    }
    return errorText;
};
export const checkFileType = (file, fileTypes) => {
    let types = fileTypes;
    types = types.map((item) => item.trim().toLowerCase());

    let fileExtension = file.fileExtension;
    if (!fileExtension && file.name.split('.').length > 1) {
        fileExtension = file.name.split('.').reverse()[0];
    }
    fileExtension = fileExtension.toLowerCase();

    if (types === '' || types.indexOf(fileExtension) !== -1) {
        return true;
    }
    return false;
};
export const checkFileSize = (file, maxSize) => {
    let result = false,
        max = $$.string.fileSize2Byte(maxSize);
    if (!max) {
        return true;
    }

    if (file.size < max) {
        result = true;
    }
    return result;
};